import './index.css';
import { AppRouter } from '@semantical/Router';

import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import Vocabulary from '@semantical/core/modules/vocabulary/Vocabulary';
import N3 from 'n3';
import { createWorkspace, setInitialConfig } from '@semantical/core/modules/workspace-config';
import initialConfig from '@semantical/config/workspace-config.json';
import type { WorkspaceConfigRoot } from '@semantical/core/modules/workspace-config';

const vocabulary = new Vocabulary(new N3.Store());

// Register the initial workspace config before creating the workspace
setInitialConfig(initialConfig as WorkspaceConfigRoot);

// Create the workspace - this loads from localStorage or initial config
const { workspace, config: workspaceConfig } = createWorkspace();

const root = createRoot(document.getElementById('appContainer')!);
root.render(
    <StrictMode>
        <AppRouter vocabulary={vocabulary} workspace={workspace} workspaceConfig={workspaceConfig} />
    </StrictMode>
);


